import { render, staticRenderFns } from "./Lightweight.vue?vue&type=template&id=7f917a46&scoped=true"
import script from "./Lightweight.vue?vue&type=script&lang=js"
export * from "./Lightweight.vue?vue&type=script&lang=js"
import style0 from "./Lightweight.vue?vue&type=style&index=0&id=7f917a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f917a46",
  null
  
)

export default component.exports